import React from 'react'
import {Icon} from '@chakra-ui/react'

const MailIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" {...props}>
            <path
                d="M0 3V21H24V3H0ZM21.36 5L12 12.24L2.64 5H21.37H21.36ZM22 19H2V7.04L12 14.77L22 7.04V19Z"
                fill="black"
            />
        </Icon>
    )
}

export default MailIcon
